import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ui-scrollspy',
  templateUrl: './ui-scrollspy.component.html',
  styleUrls: ['./ui-scrollspy.component.scss']
})
export class UiScrollspyComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  Scroll1() {
    document.getElementById("fat").scrollIntoView();
  }

  Scroll2() {
    document.getElementById("mdo").scrollIntoView();
  }

  Scroll3() {
    document.getElementById("one").scrollIntoView();
  }
  Scroll4() {
    document.getElementById("two").scrollIntoView();
  }

  Scroll5() {
    document.getElementById("three").scrollIntoView();
  }

  Scroll11() {
    document.getElementById("item-1").scrollIntoView();
  }
  Scroll12() {
    document.getElementById("item-1-1").scrollIntoView();
  }
  Scroll13() {
    document.getElementById("item-1-2").scrollIntoView();
  }
  Scroll14() {
    document.getElementById("item-2").scrollIntoView();
  }
  Scroll15() {
    document.getElementById("item-3").scrollIntoView();
  }
  Scroll16() {
    document.getElementById("item-3-1").scrollIntoView();
  }
  Scroll17() {
    document.getElementById("item-3-2").scrollIntoView();
  }

  Scrolllist() {
    document.getElementById("list-item-1").scrollIntoView();
  }
  Scrolllist1() {
    document.getElementById("list-item-2").scrollIntoView();
  }
  Scrolllist2() {
    document.getElementById("list-item-3").scrollIntoView();
  }

  Scrolllist3() {
    document.getElementById("list-item-4").scrollIntoView();
  }

}
